import React from "react";
import Reviews from "@/components/Reviews";
import FreeAppraisal from "@/components/Common/FreeAppraisal";
import Metadata from "@/components/Metadata";
import { createClient } from "../../prismicio";
import Layout from "@/components/Layout";

const CustomerReviews = ({ page, globals }) => {
  const pageData = page?.data;
  const commonComponents = globals?.data;

  return (
    <Layout data={commonComponents}>
      <Metadata
        title={pageData?.metadata_title}
        description={pageData?.metadata_desc}
        image={pageData?.metadata_image?.url}
        path="/customer-reviews"
      />
      <Reviews
        caption={pageData?.caption}
        title={pageData?.title}
        description={pageData?.description}
        testormonials={pageData?.testormonial}
      />
      <FreeAppraisal page={"Reviews"} />
      <div style={{ height: "40px" }}></div>
    </Layout>
  );
};

export default CustomerReviews;

export async function getStaticProps({ previewData }) {
  const client = createClient({ previewData });

  const page = await client.getSingle("customer_reviews");
  const globals = await client.getSingle("globals");

  return {
    props: {
      page,
      globals,
    },
  };
}
